export * from './assignable-fleet';
export * from './assignment-logs.model';
export * from './athr-operation-card.model';
export * from './audit-trail.model';
export * from './bank-info.model';
export * from './brand';
export * from './bulk-driver-with-truck.model';
export * from './bulk-driver.model';
export * from './bulk-truck.model';
export * from './classified-tadelanes.model';
export * from './classified-tradelane.model';
export * from './driver';
export * from './driver-details';
export * from './driver-report';
export * from './driver-shipment-counts.model';
export * from './driver-with-truck';
export * from './driver.model';
export * from './drivers-block';
export * from './drivers-counts';
export * from './elm';
export * from './elm-fleet-info';
export * from './fleet';
export * from './fleet-configuration-model';
export * from './fleet-delivery-note-shipments.model';
export * from './fleet-details';
export * from './fleet-has-payments-details.model';
export * from './fleet-has-payments.model';
export * from './fleets-details';
export * from './insurance-model';
export * from './permitted-access.model';
export * from './planning-truck.model';
export * from './plate-number-details.model';
export * from './rented-truck-contract.model';
export * from './rented-truck-report.model';
export * from './rented-truck-status-history.model';
export * from './rented-truck-status.model';
export * from './rented-truck.model';
export * from './rented-trucks-status.model';
export * from './status-history';
export * from './trailer.model';
export * from './transaction';
export * from './trip-planning-trucks.model';
export * from './truck';
export * from './truck-has-shipment.model';
export * from './truck-location.modal';
export * from './truck-non-contract-days.model';
export * from './truck-path.model';
export * from './truck-profits.model';
export * from './truck-shipment-counts.model';
export * from './truck-status-range.model';
export * from './truck-type';
export * from './truck-type-route-time';
export * from './trucks-counts';
export * from './trucks-details.modal';
export * from './trucks-non-contracted-days.model';
export * from './trucks-performance.model';
export * from './trucks-report';
export * from './trucks-shipments.model';
